var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper", staticStyle: { height: "100vh" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLoaing,
              expression: "isLoaing"
            }
          ],
          staticClass: "text-center",
          staticStyle: {
            position: "absolute",
            "padding-top": "130px",
            "text-align": "center",
            width: "100%"
          }
        },
        [
          _c("img", {
            staticStyle: { width: "100px", height: "66px" },
            attrs: { src: require("./img/async-loading-spinner.gif") }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container a-coupon" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("p", { staticClass: "a-coupon__product-text" }, [
          _vm._v("제공되는 음료의 종류는 현장 상황에 따라 변경될 수 있습니다.")
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "a-coupon__button-wrap" }, [
          _c("p", { staticClass: "a-coupon__button-text" }, [
            _vm._v("버튼을 클릭 시 교환 완료 처리되니 주의해 주세요.")
          ]),
          _vm._v(" "),
          _vm.isOpen
            ? _c(
                "button",
                {
                  staticClass: "a-coupon__button",
                  attrs: { type: "button" },
                  on: { click: _vm.loadCouponExchange }
                },
                [_vm._v("직원 확인")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isUsed
            ? _c(
                "button",
                {
                  staticClass: "a-coupon__button",
                  attrs: { type: "button", disabled: "" }
                },
                [_vm._v("교환 완료")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isExpired
            ? _c(
                "button",
                {
                  staticClass: "a-coupon__button",
                  attrs: { type: "button", disabled: "" }
                },
                [_vm._v("사용기간만료")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isCorrect
            ? _c(
                "button",
                {
                  staticClass: "a-coupon__button",
                  attrs: { type: "button", disabled: "" }
                },
                [_vm._v("잘못된 쿠폰입니다")]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "a-coupon__title" }, [
      _c("span", { staticClass: "underline" }, [_vm._v("A-Station 스타시티")]),
      _vm._v("를 "),
      _c("br"),
      _vm._v("\n              방문해 주셔서 감사드립니다.\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "a-coupon__product" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/@coupon_thumb.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "a-coupon__info" }, [
      _c("div", { staticClass: "a-coupon__info-row" }, [
        _c("dt", { staticClass: "a-coupon__info-title" }, [_vm._v("쿠폰명")]),
        _vm._v(" "),
        _c("dd", { staticClass: "a-coupon__info-desc" }, [
          _vm._v("XS 에너지 드링크 교환권")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "a-coupon__info-row" }, [
        _c("dt", { staticClass: "a-coupon__info-title" }, [_vm._v("사용처")]),
        _vm._v(" "),
        _c("dd", { staticClass: "a-coupon__info-desc" }, [
          _vm._v("A-Station 스타시티 파이토 카페")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "a-coupon__info-row" }, [
        _c("dt", { staticClass: "a-coupon__info-title" }, [_vm._v("사용기한")]),
        _vm._v(" "),
        _c("dd", { staticClass: "a-coupon__info-desc" }, [
          _vm._v("받은 당일에만 교환 가능")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "a-coupon__info-row" }, [
        _c("dt", { staticClass: "a-coupon__info-title" }, [_vm._v("사용안내")]),
        _vm._v(" "),
        _c("dd", { staticClass: "a-coupon__info-desc" }, [
          _vm._v("A-Station 스타시티 파이토 카페"),
          _c("br"),
          _vm._v("직원에게 본 화면을 보여주시면"),
          _c("br"),
          _c("span", { staticClass: "underline" }, [
            _vm._v("직원 확인 후 음료를 교환")
          ]),
          _vm._v("해 드립니다.")
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-399db7d8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399db7d8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/astation/coupon.vue
// module id = null
// module chunks = 